export default __webpack_public_path__ + "static/media/banner.9c4a4423.jpg";